module.exports = __webpack_public_path__ + "static/media/body_tu4.b7e53ca9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/body_tu4.jpg
// module id = 1582
// module chunks = 10